import React from "react"

export default function Footer() {
  return (
    <div className="copyright">
      &copy; Philip A. Stevenson. Powered by <a href="https://www.gatsbyjs.org">Gatsby</a> and <a href="https://www.netlify.com">Netlify</a>. Template Design by <a href="https://html5up.net">HTML5 UP</a>.
    </div>
  );
}
